import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';
import { AppUser } from 'src/app/core/models';
import { NotificationService } from 'src/app/core/services/notification.service';
import { NotificationSummary } from 'src/app/core/models/ticket.model';
import { AppRoutes } from '../../routes/routes';
import { PermissionsUtils } from '../../utils/permissions.utils';

@Component({
  selector: 'app-customer-service-icon',
  templateUrl: './customer-service-icon.component.html',
  styleUrls: ['./customer-service-icon.component.scss']
})
export class CustomerServiceIconComponent implements OnInit, OnDestroy {
  routes = AppRoutes;
  user!: AppUser;
  notificationSummary: NotificationSummary = {
    unread_tickets_count: 0,
    unread_responses_count: 0,
    new_tickets_count: 0,
    total_unread: 0
  };

  private destroy$ = new Subject<void>();
  private router = inject(Router);
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);

  constructor() {}

  ngOnInit(): void {
    // Subscribe to user changes
    this.authService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.user = user as AppUser;
      });

    // Subscribe to notification updates
    this.notificationService.getNotificationSummary()
      .pipe(takeUntil(this.destroy$))
      .subscribe(summary => {
        this.notificationSummary = summary;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openTickets(): void {
    this.router.navigate([this.routes.tickets.myTickets]);
  }

  hasPermission(permission: string): boolean {
    return PermissionsUtils.hasPermission(this.user?.permissions || [], permission);
  }

  get totalUnreadCount(): number {
    // For client users (those without manage_tickets permission), show their unread responses
    if (!this.hasPermission('manage_tickets')) {
      return this.notificationSummary.unread_responses_count;
    }
    return 0; // Staff users see notifications in sidebar, not in navbar
  }


}
